import { lazy, type ComponentType } from "react";

/**
 * After a new version is deployed, an open tab still points at the old (deleted) code files. When one of
 * them fails to load, reload the page once to pick up the new version instead of showing an error.
 */
const RELOAD_KEY = "orderai:chunk-reload";
export const lazyWithReload = <T extends ComponentType>(loader: () => Promise<{ default: T }>) =>
  lazy(() =>
    loader().then(
      (m) => {
        try {
          sessionStorage.removeItem(RELOAD_KEY);
        } catch {
          /* storage unavailable */
        }
        return m;
      },
      (err) => {
        let reloaded = false;
        try {
          reloaded = sessionStorage.getItem(RELOAD_KEY) === "1";
          if (!reloaded) sessionStorage.setItem(RELOAD_KEY, "1");
        } catch {
          reloaded = true; // cannot remember: do not risk a reload loop
        }
        if (!reloaded) {
          window.location.reload();
          return new Promise<{ default: T }>(() => {}); // wait for the reload
        }
        throw err;
      },
    ),
  );
